import React from 'react';
import s from './DetailRow.module.css';

// A labelled read-only value. The en dash for an absent value is deliberate and
// shared: a blank cell reads as a rendering fault, a dash reads as "nothing
// here", and having it in one place stops half the app using one and half the
// other.
export default function DetailRow({ label, value }) {
  return (
    <div className={s.row}>
      <div className={s.label}>{label}</div>
      <div className={s.value}>{value ?? '–'}</div>
    </div>
  );
}
